module.exports = __webpack_public_path__ + "assets/img/12_150.40712656.jpg";